export default function FamePanel() {
    return <>Fame</>
}